// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import { make } from 'UIComponents/core/SimpleDate';
export const EDITOR_TYPES = {
  CUSTOMIZE: 'CUSTOMIZE',
  CREATE_CATEGORIES: 'CREATE_CATEGORIES',
  CREATE_ARTICLE: 'CREATE_ARTICLE'
};
export const EMPTY_STRING = '';
export const EMPTY_ARRAY = [];
export const MIN_CUSTOM_DATE = make(2018, 0, 1);